import React from 'react';
import Hero from '../components/Hero';
import SupperClup from '../components/SupperClup';
import AboutSection from '../components/AboutSection';
import Newsletter from '../components/Newsletter';
import RecipeCategories from '../components/RecipeCategories';

const CategoryPage = () => {
  return (
    <div className="home-page">
      <Hero />
      <SupperClup />
      <RecipeCategories />
      <AboutSection />
      <Newsletter />
    </div>
  );
};

export default CategoryPage;